import { useFlags as useFeatureFlags } from "launchdarkly-react-client-sdk"

interface FeaturesFlags {
  logoutButton: boolean
  cosmosSelector: boolean
  spokenOnboarding: boolean
}

const defaultFlags: FeaturesFlags = {
  logoutButton: false,
  cosmosSelector: false,
  spokenOnboarding: false,
}

export default function useFlags() {
  const flags = useFeatureFlags<FeaturesFlags>()
  return { ...defaultFlags, ...flags }
}
